import { styled } from '@clickcease/cc-client-components-lib'
export const DomainReactivationModalInner = styled('div', {
  width: '592px',
  height: '500px',
  display: 'flex',
  flexDirection: 'column',
})

export const DomainReactivationModalSearch = styled('div', {
  height: '32px',
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '20px 24px 10px',
})

export const DomainReactivationList = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  padding: '0px 22px 0px 24px',
})

export const DomainReactivationListWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  minHeight: '240px',
  maxHeight: '240px',
  paddingRight: '$5',
})

export const DomainReactivationListRow = styled('div', {
  display: 'flex',
  borderBottom: '1px solid $veryLightNeutral',
  height: '58px',
  justifyContent: 'space-between',
})

export const DomainReactivationListRowText = styled('div', {
  fontSize: '$l',
  lineHeight: '58px',
  marginLeft: '$3',
})

export const DomainReactivationListHeader = styled('div', {
  display: 'flex',
  borderBottom: '1px solid $veryLightNeutral',
  height: '58px',
  lineHeight: '58px',
})

export const DomainReactivationListHeaderTitleWrapper = styled('div', {
  display: 'flex',
  width: '347px',
  justifyContent: 'space-between',
})

export const DomainReactivationListHeaderTitle = styled('div', {
  fontWeight: '$sb',
  marginLeft: '$3',
})

export const DomainReactivationSelectProductWrapper = styled('div', {
  display: 'flex',
  marginTop: '$6',
  width: '240px',
})

export const DomainReactivationListRowDomainWrapper = styled('div', {
  display: 'flex',
})

export const DomainReactivationNewDomainWrapper = styled('div', {
  display: 'flex',
  marginTop: '$10',
})

export const DomainReactivationError = styled('div', {
  height: '33px',
  color: '$error',
  fontSize: '$md',
  lineHeight: '34px',
  marginLeft: '10px',

  variants: {
    serverError: {
      true: {
        lineHeight: '17px',
      },
    },
  },
})
